module.exports = __webpack_public_path__ + "img/xdf1v1.876749b8.png";